import script from "./currentExam.vue?vue&type=script&setup=true&lang=js"
export * from "./currentExam.vue?vue&type=script&setup=true&lang=js"

import "./currentExam.vue?vue&type=style&index=0&id=d9f1bf2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9f1bf2c"]])

export default __exports__